import { SyntheticEvent } from 'react';
import * as React from 'react';
import Tooltip from '@sdk/common/tooltip/Tooltip';
import gettext from '@sdk/lang/gettext';

import GifIcon from '@web/assets/svg/UI/gif-gray-bg.svg';
import GifActiveIcon from '@web/assets/svg/UI/gif-white-bg.svg';

import EditorToolbarButton from './EditorToolbarButton';

type Props = {
  isActive: boolean;
  toggle: () => void;
};

const GifPickerButton: React.FC<React.PropsWithChildren<Props>> = ({ isActive, toggle }) => {
  return (
    <EditorToolbarButton
      data-for="gif-picker-tip"
      data-tip={gettext('Add gif')}
      data-place="top"
      borderRadius={2}
      isActive={isActive}
      onMouseDown={(e: SyntheticEvent): void => {
        e.preventDefault();
        toggle();
      }}>
      {isActive ? <GifActiveIcon /> : <GifIcon />}
      <Tooltip id="gif-picker-tip" />
    </EditorToolbarButton>
  );
};

export default GifPickerButton;
